import { getPaletteColor } from "theme/helpers";
import { TStyles } from "utils/Styles";

const styles: TStyles = {
  container: (theme) => ({
    pt: "20px",
    pb: "32px",
    color: getPaletteColor("common.white"),

    "span:not(:first-of-type)": {
      pl: "31px",
    },

    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },

    span: {
      [theme.breakpoints.down("sm")]: {
        display: "block",

        "&:not(:first-of-type)": {
          pl: "0px",
        },
      },
    },

    a: {
      display: "inline-block",
      color: getPaletteColor("common.white"),

      "&:not(:first-of-type)": {
        ml: "21px",
      },
    },
  }),
};

export default styles;
